import AuthTypes from './types';

export const authRequest = (usuario, senha) => ({
  type: AuthTypes.AUTH_REQUEST,
  payload: { usuario, senha },
});

export const authSuccess = ({ usuario, token, refreshToken }) => ({
  type: AuthTypes.AUTH_SUCCESS,
  payload: { usuario, token, refreshToken },
});

export const authFailure = () => ({
  type: AuthTypes.AUTH_FAILURE,
});

export const authLogout = () => ({
  type: AuthTypes.AUTH_LOGOUT,
});